import React, { useState, useEffect } from "react";
import SMSelect from "../../elements/select/SMSelect";
import HasilKuisBox from "./components/HasilKuisBox";
import HasilKuisTable from "./components/HasilKuisTable";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";
import HasilKuisDetailPilihanGanda from "./detail/HasilKuisDetailPilihanGanda";
import HasilKuisDetailLikert from "./detail/HasilKuisDetailLikert";
import HasilKuisDetailFile from "./detail/HasilKuisDetailFile";
import axiosAPI from "../../utils/axios-api";

const API = process.env.REACT_APP_API;

const HasilKuis = () => {
  const [selectedType, setselectedType] = useState("grid");
  const [dataKuesioner, setdataKuesioner] = useState([]);
  let { path } = useRouteMatch();
  let type = [
    { value: "table", label: "table" },
    { value: "grid", label: "grid" },
  ];

  useEffect(() => {
    getHasil()
  }, []);

  let dummy = [
    { link: "/hasil-kuis/hasil-kuis-pilihan-ganda" },
    { link: "/hasil-kuis/hasil-kuis-likert" },
    { link: "/hasil-kuis/hasil-kuis-file" },
  ];

  function getHasil(params) {
    axiosAPI.get(API + "rekap/summary?sort=-created_at").then((res) => {
      setdataKuesioner(res.data.data)
    })
  }
  return (
    <>
      <Router>
        <Switch>
          <Route path={path} exact>
            <div
              className="w-full flex flex-col p-10 dark:text-white"
              style={{ minHeight: "100vh" }}
            >
              <div className="block mb-8">
                <div className="flex">
                  <h1 className="text-3xl font-bold mr-4">Hasil Kuis</h1>
                  <div className="flex w-40">
                    <SMSelect
                      data={type}
                      defaultValue={type[1]}
                      onChange={(e) => setselectedType(e.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col">
                {selectedType !== "grid" ? (
                  <HasilKuisTable data={dataKuesioner} />
                ) : (
                  dataKuesioner.map((val, idx) => {
                    return <HasilKuisBox key={idx} data={val} />;
                  })
                )}
              </div>
            </div>
          </Route>
          <Route path={`${path}/hasil-kuis-pilihan-ganda`}>
            <HasilKuisDetailPilihanGanda />
          </Route>
          <Route path={`${path}/hasil-kuis-liklert`}>
            <HasilKuisDetailLikert />
          </Route>
          <Route path={`${path}/hasil-kuis-file`}>
            <HasilKuisDetailFile />
          </Route>
        </Switch>
      </Router>
    </>
  );
};

export default HasilKuis;
